import { useCallback, useMemo, useState } from "react"

export const useSingleModal = (initial = null) => {
  const [current, setCurrent] = useState(initial)

  const open = useCallback((id) => setCurrent(id), [])
  const close = useCallback(() => setCurrent(null), [])
  const isOpen = useCallback((id) => current === id, [current])

  const propsFor = useCallback(
    (id, overrides = {}) => ({
      visible: current === id,
      onCancel: () => close(),
      ...overrides
    }),
    [current, close]
  )

  return useMemo(
    () => ({
      currentModal: current,
      open,
      close,
      isOpen,
      propsFor
    }),
    [current, open, close, isOpen, propsFor]
  )
}
